import React from "react";
import TravelSectionItem from './travel_section_item.js';

import '../styles/components.css';
import { CustomTypoH2 } from "../helper/headings.js";


const TravelPartner = () => {
    return (
        <div className='travel-section4'>
            <div >
                <CustomTypoH2
                    typo={"The travel partner you need for your business"}
                />
            </div>
            <div className='travel-section4b'>
                <TravelSectionItem
                    image={require("../assets/travel/inventory_icon.png")}
                    heading="Inventory"
                    content="Largest inventory you can find anywhere. Really."
                />
                <TravelSectionItem
                    image={require("../assets/travel/credit_icon.png")}
                    heading="Credit"
                    content="Business travel finance to assist you with your business trips."
                />
                <TravelSectionItem
                    image={require("../assets/travel/invoicing_icon.png")}
                    heading="Invoicing"
                    content="Simpler expense management through self generting invoice system."
                />
                <TravelSectionItem
                    image={require("../assets/travel/reporting_icon.png")}
                    heading="Reporting"
                    content="Analyze spending in real-time with data-driven insights."
                />
                <TravelSectionItem
                    image={require("../assets/travel/policy_icon.png")}
                    heading="Built in Policy"
                    content="Our platform incorporates travel policy and booking guidelines."
                />
                <TravelSectionItem
                    image={require("../assets/travel/2474_icon.png")}
                    heading="2474U"
                    content="Whenever you need assistance, our friendly travel experts are always available."
                />
            </div>
        </div>


    )
}

export default TravelPartner;